import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/ProductGroup").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/ProductGroup/GetActiveList").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/ProductGroup/GetSingle?id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddProductGroup(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/ProductGroup/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditProductGroup(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/ProductGroup/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteProductGroup(id:number):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/ProductGroup/Delete?id="+id).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

}
